<div>
    <div class="breadcrumb-block">
        <FlashMessage></FlashMessage>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name:'business-dashboard'}">Home</router-link>
                </li>
                <li aria-current="page" class="breadcrumb-item active">Profile</li>
            </ol>
        </nav>
    </div>
    <div class="manage-package-block">
        <div class="white-box">
            <div class="table-title">
                <h5>Update User Profile</h5>
            </div>
            <div class="container-fluid">
                <div class="content-block">
                    <div class="error-list" v-if="ui.error.error_message">
                        <ul class="error-msg">
                            <li :key="x" v-for="(error,x) in ui.error.error_message">
                                <div :key="i" v-for="(err,i) in error">
                                    <p> {{err}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="form-modified">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="">First name*</label>
                                        <div v-if="!ui.status.editProfile">

                                            <label class="readonly" for=""
                                                   v-if="item.userData">{{item.userData.firstname}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input :class="{ 'error-input' : ui.error.errors['first_name'] }"
                                                   class="form-control"
                                                   id="inputPassword"
                                                   placeholder="First Name"
                                                   type="text"
                                                   v-model="item.userData.firstname"/>
                                            <validation-error :errors="ui.error.errors" :field="'first_name'"
                                                              :isError="ui.error.has_error"
                                                              v-if="ui.error.has_error"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Last name*</label>
                                        <div v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.userData">{{item.userData.lastname}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input :class="{ 'error-input' : ui.error.errors['last_name'] }"
                                                   class="form-control"
                                                   id="inputPassword"
                                                   placeholder="Last Name" type="text"
                                                   v-model="item.userData.lastname"/>
                                            <validation-error :errors="ui.error.errors" :field="'last_name'"
                                                              :isError="ui.error.has_error"
                                                              v-if="ui.error.has_error"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Address Line1</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.address_line1">{{item.profileData.address_line1}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input class="form-control" id="inputPassword"
                                                   placeholder="Company Address Line 1"
                                                   type="text"
                                                   v-model="item.profileData.address_line1"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Address Line2</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.address_line2">{{item.profileData.address_line2}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input class="form-control" id="inputPassword"
                                                   placeholder="Company Address Line 2"
                                                   type="text"
                                                   v-model="item.profileData.address_line2"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">City</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.city">{{item.profileData.city}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input class="form-control" id="inputPassword" placeholder="Company City"
                                                   type="text" v-model="item.profileData.city"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Country</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.country">{{item.profileData.country}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input :class="{ 'error-input' : ui.error.errors['country_name'] }"
                                                   class="form-control"
                                                   id="inputPassword"
                                                   placeholder="Company Country" type="text"
                                                   v-model="item.profileData.country"/>
                                            <validation-error :errors="ui.error.errors" :field="'country_name'"
                                                              :isError="ui.error.has_error"
                                                              v-if="ui.error.has_error"/>

                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Province</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.province">{{item.profileData.province}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input :class="{ 'error-input' : ui.error.errors['country_name'] }"
                                                   class="form-control"
                                                   id="inputPassword"
                                                   placeholder="Company Country" type="text"
                                                   v-model="item.profileData.province"/>
                                            <validation-error :errors="ui.error.errors" :field="'country_name'"
                                                              :isError="ui.error.has_error"
                                                              v-if="ui.error.has_error"/>

                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Zip code</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.zip">{{item.profileData.zip}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input :class="{ 'error-input' : ui.error.errors['country_zip'] }"
                                                   @keypress="preventNonNumericalInput($event)"
                                                   class="form-control" id="inputPassword" placeholder="Company Zip"
                                                   type="text"
                                                   v-model="item.profileData.zip"/>
                                            <validation-error :errors="ui.error.errors" :field="'country_zip'"
                                                              :isError="ui.error.has_error"
                                                              v-if="ui.error.has_error"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Mobile 1</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.mobile1">{{item.profileData.mobile1}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input @keypress="preventNonNumericalInput($event)" class="form-control"
                                                   id="contact2" placeholder="Company Contact 2" type="text"
                                                   v-model="item.profileData.mobile1"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Mobile 2</label>
                                        <div class="form-group" v-if="!ui.status.editProfile">
                                            <label class="readonly" for=""
                                                   v-if="item.profileData.mobile2">{{item.profileData.mobile2}}</label>
                                            <label class="readonly" for="" v-else>-</label>
                                        </div>
                                        <div class="form-group" v-else>
                                            <input @keypress="preventNonNumericalInput($event)" class="form-control"
                                                   id="contact2" placeholder="Company Contact 2" type="text"
                                                   v-model="item.profileData.mobile2"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">

                                <div class="form-group custom-file" v-if="ui.status.editProfile && item.profileData.profile_image === null">

                                    <input @click.prevent="onUploadProfileImage('image')"
                                           accept="image/*" class="custom-file-input"
                                           data-toggle="modal" id="customDocument"
                                           type="file"> <label
                                        class="custom-file-label" for="customDocument">Browse
                                    Image</label>
                                </div>
                                <UploadFile
                                        :checkTitle="ui.status.checkTitle"
                                        :limitdata="vars.limitdata"
                                        :postdata="vars.postdata"
                                        :shouldfileupload="ui.status.fileupload"
                                        :titles="vars.titles"
                                        @closeUploadModal="closeUploadModal"
                                        @documentUploaded="documentUploaded"
                                        v-if="ui.status.fileupload"
                                ></UploadFile>
                                <div class="profile-img-block mt-5" v-if="!ui.status.editProfile">
                                    <img :src="item.profileData.profile_image_path" alt="" v-if="item.profileData.profile_image!==null">
                                    <img alt="" src="https://dummyimage.com/100X100/000/fff.jpg" v-else/>
                                </div>
                                <div class="profile-img-block mt-5" v-if="ui.status.editProfile && item.profileData.profile_image!==null">
                                    <img :src="item.profileData.profile_image_path" alt="">
                                    <span @click.prevent="onUploadProfileImage('image')" class="btn btn-primary btn-sm">
                                    Edit
                                </span>
                                </div>
                                <label class="mt-2" for="">Alternative contact person</label>
                                <div class="form-group" v-if="!ui.status.editProfile">
                                    <label class="readonly" for=""
                                           v-if="item.profileData.contact_person">{{item.profileData.contact_person}}</label>
                                    <label class="readonly" for="" v-else>-</label>
                                </div>
                                <div class="form-group" v-else>
                                    <input class="form-control" id="text" placeholder="Company Contact Person"
                                           type="text"
                                           v-model="item.profileData.contact_person"/>
                                </div>
                                <label for="">Alternative contact person's number</label>
                                <div class="form-group" v-if="!ui.status.editProfile">
                                    <label class="readonly" for=""
                                           v-if="item.profileData.contact_person_mobile">{{item.profileData.contact_person_mobile}}</label>
                                    <label class="readonly" for="" v-else>-</label>
                                </div>
                                <div class="form-group" v-else>
                                    <input @keypress="preventNonNumericalInput($event)" class="form-control"
                                           id="inputPassword"
                                           placeholder="Personal Phone 1" type="text"
                                           v-model="item.profileData.contact_person_mobile"/>
                                </div>
                            </div>
                        </div>

                        <hr>

                        <div class="form-group">
                            <button @click.prevent="onEditProfileClick" class="default-btn" type="submit"
                                    v-if="!ui.status.editProfile">
                                Edit
                                <spinner :loading="ui.status.postLoading.editProfile"
                                         v-if="ui.status.postLoading.editProfile"></spinner>
                            </button>
                            <button @click.prevent="updateProfile"
                                    class="default-btn save-btn"
                                    type="submit" v-if="ui.status.editProfile">
                                Save
                                <spinner :loading="ui.status.postLoading.editProfile"
                                         v-if="ui.status.postLoading.editProfile"></spinner>
                            </button>
                            <button :disabled="ui.status.postLoading.editProfile" @click.prevent="onCancelProfileClick"
                                    class="default-btn cancel"
                                    type="submit" v-if="ui.status.editProfile">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
